import template from './ContactFormField.html';

export default {
  name: 'ContactFormField',

  template,

  props: {
    initContent: {
      type: Object,
      required: true,
    },
    uniqueId: String,
  },

  data() {
    return {
      content: this.initContent,
    };
  },

  created() {
    this.validateContent(this.initContent);
  },

  // Methods

  methods: {
    validateContent(content) {
      if (typeof content.contact_form.title === 'undefined' || typeof content.contact_form.mailTo === 'undefined') {
        throw new Error('Invalid content given to ContactFormField');
      }

      return true;
    },

  },
};
